

/// <reference path="AccountingJournalLineTemplate.ts" />

// Generated class AccountingJournalLineFormulaTemplate_ManagedObject

class AccountingJournalLineFormulaTemplate_ManagedObject extends AccountingJournalLineTemplate
{

    // Property: keyFormula
    set keyFormula(value:string) {
        this.setValueForKey(value, 'keyFormula');
    }
    get keyFormula():string {
        return this.valueForKey('keyFormula');
    }
    set keyFormulaPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'keyFormula');
    }
    get keyFormulaPrimitiveValue():string {
        return this.primitiveValueForKey('keyFormula');
    }

    // Property: valueFormula
    set valueFormula(value:string) {
        this.setValueForKey(value, 'valueFormula');
    }
    get valueFormula():string {
        return this.valueForKey('valueFormula');
    }
    set valueFormulaPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'valueFormula');
    }
    get valueFormulaPrimitiveValue():string {
        return this.primitiveValueForKey('valueFormula');
    }
}
